module.exports = __webpack_public_path__ + "img/arrow-next.d84c4306.svg";